import React from 'react';

import Input from 'components/shared/Input/Input';

const PhysicalAssetKindBasic = ({ formik }) => {
  return (
    <>
      <Input
        label="Asset Tag"
        data-qa="physical-asset-kind-terminal-asset-tag"
        name="asset_tag"
        isOptional
        type="text"
        value={formik.values.asset_tag}
        onChange={formik && formik?.handleChange}
      />
      <Input
        isOptional
        label="Notes"
        data-qa="physical-asset-notes"
        name="data.notes"
        type="text"
        value={formik.values.data.notes}
        onChange={formik && formik?.handleChange}
      />
    </>
  );
};

export default PhysicalAssetKindBasic;
